import '../styles/theme.scss';
import throttle from 'lodash/throttle';
import { initPromoBannerMenu } from '../templates/common/promo-banner-menu/promo-banner-menu';
import { useOffsetBoxes, calcOffsetBoxesSize } from './utils/offsetBoxes';
import { toggleClass } from './utils/toggleClass/toggleClass';
import {
  sendCustomEvent,
  sendCustomPageEvent,
  sendCustomPromoBannerEvent,
  sendLinkEvent,
} from './config/analytics';
import { Modal } from '../templates/common/modal/modal';
import * as drawers from './components/drawers';

// Sections
import {
  initThemeHeaderNavigation,
  initThemeHeaderAddToCart,
} from '../snippets/theme-header-navigation/theme-header-navigation';
import { initCarrotButton } from '../snippets/carrot-button/carrot-button';
import { initThemeMobileNavigation } from '../templates/common/theme-mobile-navigation/theme-mobile-navigation';
import { activateElOnScroll } from './utils/activateElOnScroll';

// Snippets
import { initStickyBanner } from '../snippets/email-subscribe/email-subscribe';
import { initNavDropDownHoverEffect } from '../templates/common/site-header/site-header';

window.drawers = drawers;
drawers.initDrawers();
initPromoBannerMenu();
initCarrotButton();
initThemeHeaderNavigation();
initThemeMobileNavigation();
saveUTMTags();

window.addEventListener('resize', () => useOffsetBoxes());
useOffsetBoxes();

document.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    sendLinkEvent({
      category: document.body.id,
      action: link.href,
      label: link.ariaLabel || String(link.innerText).replace('\n', '').trim(),
    });
  });
});

window.Helpers = Object.assign(window.Helpers || {}, {
  toggleClass,
  sendCustomPageEvent,
  sendCustomPromoBannerEvent,
  sendCustomEvent,
});

window.onReady(() => {
  initNavDropDownHoverEffect();
  initStickyBanner();
  activateAnchorHash();
});

window.addEventListener('load', () => {
  setStickyHeader();
  initThemeHeaderAddToCart();
});

window.addEventListener(
  'scroll',
  throttle(() => {
    activateElOnScroll();
    setStickyHeader();
  }, 100)
);

function activateAnchorHash() {
  if (!window.location.hash) {
    return false;
  }

  window.addEventListener('load', () => {
    const scrollPosition = Number(document.documentElement.scrollTop) || 0;
    const offsetFromElement = scrollPosition - calcOffsetBoxesSize();

    document.documentElement.scrollTo(0, offsetFromElement);
  });

  return true;
}

function saveUTMTags() {
  if (window.location.search) {
    const params = new URLSearchParams(window.location.search);

    const utmSource = params.get('utm_source');

    if (utmSource) {
      window.sessionStorage.setItem('utm_source', utmSource);
    }

    const utmCampaign = params.get('utm_campaign');

    if (utmCampaign) {
      window.sessionStorage.setItem('utm_campaign', utmCampaign);
    }

    const utmMedium = params.get('utm_medium');

    if (utmMedium) {
      window.sessionStorage.setItem('utm_medium', utmMedium);
    }

    const utmTerm = params.get('utm_term');

    if (utmTerm) {
      window.sessionStorage.setItem('utm_term', utmTerm);
    }

    const utmContent = params.get('utm_content');

    if (utmContent) {
      window.sessionStorage.setItem('utm_content', utmContent);
    }
  }
}

function setStickyHeader() {
  const stickyOffset =
    document.querySelector('[data-section-top-header-offer]')?.clientHeight ||
    0;

  const isStickyHeader = window.pageYOffset > stickyOffset;

  document.body.setAttribute('data-sticky-header', isStickyHeader);
}

customElements.define('modal-component', Modal);
